module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/_property-desc.js
 ** module id = 60
 ** module chunks = 0 1
 **/